import { ROUTES } from 'module/navigation/enums/routes.enums';
import PreloadComp from 'module/preload/PreloadComp';
import { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import HeaderBar from '../HeaderBar/HeaderBar';
import MabelSidebar from '../MabelSideBar/MabelSidebar';
import { DocumentProvider } from 'module/documents/context';
import { useWorkplaceUser } from 'module/documents/utils';
import Manager from '../../../module/schedule/Manager';

export default function Layout(): JSX.Element {
	const [hoveredLayout, setHoveredLayout] = useState(false);
	const { data: user, isLoading } = useWorkplaceUser();
	const [newEmployee, setNewEmployee] = useState({
		firstName: '',
		middleName: '',
		lastName: '',
		email: '',
	});
	if (isLoading) {
		return null;
	}
	const renderLayout = (
		<div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
			<DocumentProvider
				defaultUser={user}
				newEmployeeState={[newEmployee, setNewEmployee]}
			>
				<MabelSidebar hoveredLayout={hoveredLayout} setHoveredLayout={setHoveredLayout} />
				<div style={{ flex: 1, minWidth: 0 }}>
					<HeaderBar />
					<main style={{ margin: '0 24px 48px 24px', overflow: 'hidden' }}>
						{/* <BroadcastInitProvider>
						</BroadcastInitProvider> */}
						<Switch>
								<Route path={ROUTES.MANAGER} component={Manager} />
								<Redirect from="/" to={ROUTES.DASHBOARD} />
							</Switch>
					</main>
				</div>
			</DocumentProvider>
		</div>
	);

	return <PreloadComp>{renderLayout}</PreloadComp>;
}
